var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVerifieduser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.640381 12.4734V11.7589C0.640381 8.99661 3.07168 6.75732 6.07082 6.75732",
    stroke: "#878787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3492 6.98213C11.8471 6.47861 12.7072 6.47861 13.2051 6.98213C13.4568 7.23664 13.8185 7.37461 14.1918 7.35854C14.9304 7.32674 15.5387 7.88699 15.5041 8.56728C15.4867 8.9111 15.6365 9.24421 15.9128 9.476C16.4595 9.93457 16.4595 10.7268 15.9128 11.1854C15.6365 11.4172 15.4867 11.7503 15.5041 12.0941C15.5387 12.7744 14.9304 13.3347 14.1918 13.3029C13.8185 13.2868 13.4568 13.4248 13.2051 13.6793C12.7072 14.1828 11.8471 14.1828 11.3492 13.6793C11.0975 13.4248 10.7358 13.2868 10.3625 13.3029C9.62391 13.3347 9.01562 12.7744 9.05014 12.0941C9.0676 11.7503 8.9178 11.4172 8.64146 11.1854C8.09477 10.7268 8.09477 9.93457 8.64146 9.476C8.9178 9.24421 9.0676 8.9111 9.05014 8.56728C9.01562 7.88699 9.62391 7.32674 10.3625 7.35854C10.7358 7.37461 11.0975 7.23664 11.3492 6.98213Z",
    stroke: "#878787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0078 10.3307L11.8542 11.1102L13.5468 9.55127",
    stroke: "#878787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07064 6.75712C7.78441 6.75712 9.17375 5.4775 9.17375 3.89907C9.17375 2.32061 7.78441 1.04102 6.07064 1.04102C4.35684 1.04102 2.96753 2.32061 2.96753 3.89907C2.96753 5.4775 4.35684 6.75712 6.07064 6.75712Z",
    stroke: "#878787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerifieduser);
export default __webpack_public_path__ + "static/media/icon _verified user_.0b7657de.svg";
export { ForwardRef as ReactComponent };